import React from 'react';
import { Select } from 'antd';
import { useFetchAllComs } from '../../hooks/comHooks';

const CommercialSelect = (props) => {
  const { Coms, loading, error } = useFetchAllComs();

  return (
    <Select
      {...props}
      showSearch
      allowClear
      placeholder="Sélectionner un commercial"
      optionFilterProp="label"
      loading={loading}
      listHeight={256}
      status={error ? 'error' : props.status}
      notFoundContent={
        error
          ? 'Impossible de charger les commerciaux'
          : loading ? 'Chargement...' : 'Aucun commercial trouvé'
      }
      options={Coms.map((commercial) => ({
        value: commercial.code_com,
        label: `${commercial.code_com} - ${commercial.nom || 'Sans nom'}`,
      }))}
    />
  );
};

export default CommercialSelect;
